<template>
  <div>
    <a-modal
      destroyOnClose
      :footer="null"
      :maskClosable="false"
      centered
      :title="refundable?$t('title.ReturnDetailSearch'):$t('title.ReceiptDetailSearch')"
      v-model="visible"
      width="85%"
    >
      <a-space>
        <a-input-search
          style="width: 200px"
          @pressEnter="filterByNo"
          @search="filterByNo"
          :placeholder="$t('business.label.itemNo')"
          v-model="query['no']"
        />
        <a-input-search
          style="width: 200px"
          @pressEnter="filterByName"
          @search="filterByName"
          :placeholder="$t('business.label.itemName')"
          v-model="query['name']"
        />
        <a-input-search
          style="width: 200px"
          @pressEnter="filterByBarcode"
          @search="filterByBarcode"
          :placeholder="$t('business.label.itemBarcode')"
          v-model="query['barcode']"
        />
        <a-button type="primary" @click="reset">{{ $t('button.reset') }}</a-button>
      </a-space>
      <br /><br />
      <vxe-table
        border
        stripe
        round
        show-overflow
        show-header-overflow
        :export-config="{}"
        :keyboard-config="{isArrow: true}"
        align="center"
        ref="detailTable"
        :data="data"
        :loading="loading"
        size="mini"
        :height="500"
        :scroll-x="{enabled: true}"
        :row-config="{isCurrent: true, isHover: true}"
        :column-config="{resizable: true}"
        @cell-dblclick="onDblClickRow">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="80" />
        <vxe-column field="item.name" title="business.label.itemName" width="200" />
        <vxe-column field="pack.specification" title="business.label.specification" width="200" />
        <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
        <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
        <vxe-column field="asnDetail.lotNo" title="business.label.lot" width="200" />
        <vxe-column field="asnDetail.productionDate" title="business.label.productionDate" width="100" />
        <vxe-column field="asnDetail.validUntil" title="business.label.validUntil" width="100" />
        <vxe-column field="asnDetail.manufacturer" title="business.label.manufacturer" width="150" />
        <vxe-column field="asnDetail.producingArea" title="business.label.producingArea" width="150" />
        <vxe-column field="asnDetail.approvalNo" title="business.label.approvalNo" width="150" />
        <vxe-column field="asnDetail.quantity" title="business.label.totalQuantity" width="150" />
        <vxe-column :title="refundable?'business.label.acceptedQuantity':'business.label.receivedQuantity'" field="asnDetail.receivedQuantity" width="150" />
        <vxe-column v-if="!refundable" field="asnDetail.acceptedQuantity" title="business.label.acceptedQuantity" width="150" />
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="supervised" title="business.label.supervised" width="70"/>
      </vxe-table>
    </a-modal>
  </div>
</template>
<script>
  export default {
    name: 'ReceiptAsnDetailModal',
    data() {
      return {
        visible: false,
        loading: false,
        data: [],
        query: {
          'no': '',
          'name': '',
          'barcode': ''
        },
        bakData: []
      }
    },
    props: {
      selectType: {
        type: String,
        default: 'radio'
      },
      refundable: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      open(view) {
        this.visible = true
        let i = 1
        view.forEach(item => {
          item.key = i++
        })
        this.bakData = Object.assign([], view)
        this.data = view
      },
      filterByNo() {
        this.data = this.data.filter(item => item.item.no.includes(this.query['no']))
      },
      filterByName() {
        this.data = this.data.filter(item => item.item.name.includes(this.query['name']))
      },
      filterByBarcode() {
        this.data = this.data.filter(item => item.item.barcodes.includes(this.query['barcode']))
      },
      onDblClickRow() {
        this.confirm()
      },
      handleCancel() {
        this.visible = false
      },
      confirm() {
        this.$emit('change', this.$refs.detailTable.getCurrentRecord())
        this.visible = false
      },
      reset() {
        this.query = {
          'no': '',
          'name': '',
          'barcode': ''
        }
        this.data = Object.assign([], this.bakData)
      }
    }
  }
</script>
